import React from "react";

import cn from "classnames";

import { boxForwardRef } from "../../../../../helpers/common/Box/Box";
import { Text } from "../../../../Text";

import type { BoxComponentWithDefault } from "../../../../../helpers/common/Box/Box";
import type { TextProps } from "../../../../Text";

import classes from "./ChipUserLabel.styl";

const CHIP_USER_LABEL_TEST_ID = "chip-user-label-test-id";

export type ChipUserLabel = Omit<
    TextProps,
    | "maxLines"
    | "textCase"
    | "underline"
    | "strikethrough"
    | "alignmentX"
    | "width"
    | "typographyStyle"
    | "lineHeight"
>;

export const ChipLabel = boxForwardRef<
    BoxComponentWithDefault<"span", ChipUserLabel, "className">
>(({ customVarsStyles, children, ...props }, ref) =>
    children ? (
        <Text
            data-tsid={CHIP_USER_LABEL_TEST_ID}
            {...props}
            typographyStyle="caption-m"
            maxLines={1}
            customVarsStyles={cn(
                classes["custom-vars-styles"],
                customVarsStyles,
            )}
            ref={ref}
        >
            {children}
        </Text>
    ) : null,
);

ChipLabel.displayName = "ChipUser.Label";

export default ChipLabel;
